module.exports = __webpack_public_path__ + "static/media/rio.2151e54b.jpg";